import React from 'react';
import { InputField } from 'vindi-ds-components';
import handleCEP from '@utils/handle_cep';

function CustomerCepField() {
  return (
    <InputField
      label='CEP'
      name='cep'
      handleChange={(value) => handleCEP(value)}
      mask='cep'
    />
  );
}

export default CustomerCepField;
